import { Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';

const EmptySate = ({
  variant = 'favorites',
}: {
  variant?: 'favorites' | 'notes';
}) => {
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;

  return (
    <div className="rounded-[16px] border border-gray bg-white px-2x py-[200px] md:py-4x text-center flex flex-col gap-2x justify-center items-center">
      <div className="flex h-[80px] w-[80px] items-center justify-center rounded-full text-gray__dark_1">
        <Icon name="heart" size="80px" />
      </div>
      <p className="text-title-4 text-gray__dark_2">
        {t(
          variant === 'notes'
            ? 'emptySavedNotesTitle'
            : 'emptySavedPropertiesTitle',
        )}
      </p>
      <a
        href={`${process.env.REACT_APP_BASE_URL}/${locale}/for-sale/property-type/`}
        className="w-full max-w-[311px] md:max-w-[375px] px-2x h-[40px] text-center bg-blue text-white rounded-[26px] element-center"
      >
        {t('emptySavedPropertiesButton')}
      </a>
    </div>
  );
};

export default EmptySate;
